/**
 *  weiboPendingModule
 *
 * Description 微博渠道-待审
 * author: Qian.qianchen 2018-11-21
 */
'use strict';
angular.module('weiboPendingModule', ['weiboPendingRouterModule']).controller('weiboPendingCtrl', [
    '$scope',
    '$state',
    'modalDialog',
    'editingCenterWeiBoService',
    'editcenterRightsService',
    '$q',
    'storageListenerService',
    'editingCenterService',
    'editCenUploadVideoForXjService',
    'weiboConst',
    'editingMediatype',
    'messagePublishService',
    'weiboApiParams',
    'weiboApiService',
    'noticeWindowService',
    'newMediaService',
    function (
        $scope,
        $state,
        modalDialog,
        editingCenterWeiBoService,
        editcenterRightsService,
        $q,
        storageListenerService,
        editingCenterService,
        editCenUploadVideoForXjService,
        weiboConst,
        editingMediatype,
        messagePublishService,
        weiboApiParams,
        weiboApiService,
        noticeWindowService,
        newMediaService

    ) {
        initStatus();
        initData();

        /**
         * [initStatus description]初始化状态
         * @return {[type]} [description]
         */
        function initStatus() {
            $scope.data = {
                items: [],
                keyWords: '',
            };
            $scope.page = {
                CURRPAGE: 1,
                PAGESIZE: 15,
                ITEMCOUNT: 0,
                PAGECOUNT: 1,
            };
            $scope.status = {
                channelId: $state.params.wbchannelid,
                mediaType: editingMediatype.weibo,
                'status_model': 1,
                isEsSearch: false, // 判断是否是经过ES检索之后
                copyCurrPage: 1,
                // keywords: '',
                hasRight: true,
            };
            $scope.esparams = {}; // es检索参数
            $scope.params = {
                CONTENT: '',
                docType: '',
                isPass: false,
            };
        }

        /**
         * [initData description] 初始化数据
         * @return {[type]} [description]
         */
        function initData() {
            initDropdown();
            initBtnRights();
            listenStorage();
            // requestData();
            refreshList();
        }

        // 用于记忆功能，在app.js中$transitions.onSuccess方法中调用
        $scope.requestData = function() {
            requestData();
        };
        
        /**
         * [initData description] 初始化下拉框
         * @return {[type]} [description]
         */
        function initDropdown() {
            $scope.data.docTypeJsons = weiboConst.docTypeJsons;
            $scope.data.selectedDocType = weiboConst.docTypeJsons[0];
            // editingCenterService.dealStorage($scope);
        }

        /**
         * [refreshList description]刷新列表
         * @return  {[undefined]}  [return description]
         */
        function refreshList() {
            messagePublishService.subscribe(
                'refresh',
                function (event, data) {
                    if ((typeof data) === 'object') {
                        $scope.status.isEsSearch = true; // es检索状态
                        $scope.esparams = data;
                    }
                    // 暂时的其他情况是boolean
                    else {
                        $scope.status.isEsSearch = false;
                    }
                    $scope.page.CURRPAGE = 1;
                    requestData();
                },
                $scope
            );
        }

        /**
         * [initBtnRights description] 初始化权限
         * @return {[type]} [description]
         */
        function initBtnRights() {
            editcenterRightsService.initWeiboListBtn('microblog.daishen', $scope.status.channelId).then(function (rights) {
                $scope.status.btnRights = rights;
            });
        }

        /**
         * [requestData description] 数据请求
         * @return {[type]} [description]
         */
        function requestData() {
            var deferred = $q.defer();
            let listParams = angular.extend({}, weiboApiParams.listParams, $scope.params, {
                PageIndex: $scope.page.CURRPAGE,
                PageSize: $scope.page.PAGESIZE,
                AccountId: $state.params.wbchannelid,
                FlowStatus: '20,23,24,25',
                StartTime: $scope.data.fromdate,
                EndTime: timeFormat($scope.data.untildate),
                isPass: $scope.params.isPass
            });
            var params = $scope.status.isEsSearch ? $scope.esparams : listParams;
            if ($scope.status.isEsSearch) {
                params.httpMethod = 'get';
            }
            $scope.loadingPromise = weiboApiService.getList(params).then(
                function (data) {
                    if (!$scope.status.isEsSearch) {
                        $scope.data.keyWords = '';
                    }
                    $scope.status.hasRight = true;
                    $scope.data.items = data.DATA;
                    if ($scope.data.items.length) {
                        editingCenterService.queryVerifyDoc($scope.data.items);
                    }
                    newMediaService.getReviseInfo($scope.data.items);
                    !!data.PAGER ? ($scope.page = data.PAGER) : ($scope.page.ITEMCOUNT = '0');
                    deferred.resolve(data);
                },
                function (data) {
                    $scope.status.hasRight = false;
                }
            );
            return deferred.promise;
        }

        /**
         * [isOnlyMine description] 只看通过
         *
         * @param {[type]} key   [key description]
         *
         * @return {[type]}   [return description]
         */
        $scope.isOnlyMine = function(key) {
            $scope.page.CURRPAGE = 1;
            $scope.params[key] = !$scope.params[key];
            if ($scope.status.isEsSearch) {
                messagePublishService.publish('changeEsParams');
            } else {
                requestData();
            }
        };

        /**
         * [queryByDropdown description] 下拉框回调函数
         *
         * @param   {[type]}  type   [type description]
         * @param   {[type]}  value  [value description]
         *
         * @return  {[type]}         [return description]
         */
        $scope.queryByDropdown = function(type, value) {
            $scope.page.CURRPAGE = 1;
            $scope.params[type] = value;
            if ($scope.status.isEsSearch) {
                messagePublishService.publish('changeEsParams');
            } else {
                requestData();
            }
        };

        /**
         * [listenStorage description]监听本地缓存
         * @return {[promise]} [description] promise
         */
        function listenStorage() {
            storageListenerService.listenToWeibo(function () {
                $scope.status.isEsSearch = false;
                requestData();
                storageListenerService.removeListener('weibo');
            }, $scope);
        }

        /**
         * [timeFormat description] 日期day+1处理
         * @param  {[String]} timeStr [description]日期字符串
         * @return {[type]}         [description]
         */
        function timeFormat(timeStr) {
            if (angular.isDefined(timeStr) && timeStr != '') {
                var date = timeStr.replace(/-/g, '/');
                var timestamp = new Date(date).getTime();
                timestamp = timestamp + 24 * 60 * 60 * 1000;
                var d = new Date(timestamp);
                return d.getFullYear() + '-' + (d.getMonth() + 1) + '-' + d.getDate();
            } else {
                return '';
            }
        }

        /**
         * [hasIllegalDoc description] 是否有不合法稿件
         * @param  {[type]}  arr [description] 稿件列表
         * @return {Boolean}     [description]
         */
        function hasIllegalDoc(arr) {
            return arr.some((item) => {
                if (item.PICTURE) {
                    return item.CONTENT.length > 5000 && item.PICTURE && item.PICTURE.length > 0;
                }
                return false;
            });
        }
        
        /**
         * [pageChanged description] 换页
         * @return {[type]} [description]
         */
        $scope.pageChanged = function () {
            $scope.status.copyCurrPage = $scope.page.CURRPAGE;
            requestData();
        };

        /**
         * [editWeibo description] 微博编辑
         * @param  {[object]} item [description] 微博对象
         * @return {[type]}      [description]
         */
        $scope.editWeibo = function (item) {
            if (item.FLOWSTATUS === '23') {
                modalDialog.alertType('宣传部送审中的稿件不能编辑', '', 'warning', false);
                return;
            }
            editingCenterWeiBoService.isLock(item.METADATAID).then(function (lockSituation) {
                if (lockSituation.ISLOCK == 'false') {
                    let routerParams = {
                        wbplatform: 1,
                        wbchannelid: $scope.status.channelId,
                        wbmetadataid: item.METADATAID,
                    };
                    let url = $state.href(weiboConst.doctype[item.DOCTYPEID], routerParams);
                    window.open(url);
                } else {
                    if (lockSituation.CRUSERHASFORCEDUNLOCK == 'true') {
                        modalDialog.alertType(
                            lockSituation.LOCKUSERDEPT ? '当前微博已被【' + lockSituation.LOCKUSERDEPT + '-' + lockSituation.LOCKUSER + '】锁定，您此时不能编辑' : '当前微博已被【' + lockSituation.LOCKUSER + '】锁定，您此时不能编辑',
                            '',
                            'ask',
                            true,
                            function () {
                                editingCenterWeiBoService.forceUnlockWeibo(item.METADATAID).then(
                                    function (result) {
                                        if (result.ISSUCCESS) {
                                            let routerParams = {
                                                wbplatform: 1,
                                                wbchannelid: $scope.status.channelId,
                                                wbmetadataid: item.METADATAID,
                                            };
                                            let url = $state.href(weiboConst.doctype[item.DOCTYPEID], routerParams);
                                            window.open(url);
                                        }
                                    },
                                    function (data) {
                                        modalDialog.alertType(data.DETAIL, '', 'error', 'confirm', function () { });
                                    }
                                );
                            },
                            function (data) { },
                            0,
                            '取消',
                            '强制解锁'
                        );
                    } else {
                        modalDialog.alertType(
                            lockSituation.LOCKUSERDEPT ? '当前微博已被【' + lockSituation.LOCKUSERDEPT + '-' + lockSituation.LOCKUSER + '】锁定，您此时不能编辑' : '当前微博已被【' + lockSituation.LOCKUSER + '】锁定，您此时不能编辑',
                            '',
                            'warning',
                            'confirm',
                            function () { }
                        );
                    }
                }
            });
        };

        /**
         * [timeSelect description] 时间筛选
         * @return {[type]} [description]
         */
        $scope.timeSelect = function () {
            if ($scope.status.isEsSearch) {
                messagePublishService.publish('changeEsParams');
            } else {
                requestData();
            }
        };

        /**
        * [getReviseInfo description]获取修订信息
        * @param   {[object]}  item  [item description] 稿件信息
        * @return  {[type]}          [return description]
        */
        $scope.getReviseInfo = function(item){
            newMediaService.getReviseInfo(item, 'DOCMODIFYSTATUSNAME');
        };

        /**
         * [deleteWeibo description] 微博删除
         * @param  {[object]} item [description] 需要废稿的微博对象
         * @return {[type]}      [description]
         */
        $scope.deleteWeibo = function (item) {
            editingCenterWeiBoService.isLock(item.METADATAID).then(function (lockSituation) {
                if (lockSituation.ISLOCK === 'false') {
                    modalDialog.confirmModal('', '是否确认将此微博置为废稿', function () {
                        let params = angular.extend({}, weiboApiParams.deleteParams, {
                            MicroContentIds: item.METADATAID,
                            AccountId: $state.params.wbchannelid,
                        });
                        $scope.loadingPromise = weiboApiService.delete(params).then(
                            function (data) {
                                modalDialog.alertType('废稿成功', '', 'success', false);
                                requestData();
                            }
                        );
                    });
                } else {
                    modalDialog.alertType(
                        lockSituation.LOCKUSERDEPT ? '当前微博已被【' + lockSituation.LOCKUSERDEPT + '-' + lockSituation.LOCKUSER + '】锁定，您此时不能废稿' : '当前微博已被【' + lockSituation.LOCKUSER + '】锁定，您此时不能废稿',
                        '',
                        'warning',
                        'confirm',
                        function () { }
                    );
                }
            });
        };

        /**
         * [trial description] 微博撤稿
         * @param  {[object]} item [description] 需要撤稿的微博对象
         * @return {[type]}      [description]
         */
        $scope.withdraw = function (item) {
            editingCenterWeiBoService.isLock(item.METADATAID).then(function (lockSituation) {
                if (lockSituation.ISLOCK == 'false') {
                    $scope.status.isEsSearch = false;
                    editingCenterWeiBoService.withdrawWeibo([item], function (result) {
                        modalDialog.alertType('撤稿成功', '', 'success', false);
                        requestData();

                    }, function () {
                        requestData();
                        modalDialog.alertType('撤稿失败', '', 'error', false);
                    });
                } else {
                    modalDialog.alertType(
                        lockSituation.LOCKUSERDEPT ? '当前微博已被【' + lockSituation.LOCKUSERDEPT + '-' + lockSituation.LOCKUSER + '】锁定，您此时不能撤稿' : '当前微博已被【' + lockSituation.LOCKUSER + '】锁定，您此时不能撤稿',
                        '',
                        'warning',
                        'confirm',
                        function () { }
                    );
                }
            });
        };

        /**
         * [propagandaReview description] 宣传部送审
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        $scope.propagandaReview = function (item) {
            if (item.ISVIDEO === '1') {
                modalDialog.alertType('微博视频稿件暂不支持宣传部送审', '', 'warning', false);
                return;
            }
            if (item.FLOWSTATUS === '23') {
                modalDialog.alertType('审核中的稿件不能送审', '', 'warning', false);
                return;
            }
            modalDialog.inputModel('送审', '送审意见（选填）', function (content) {
                let params = angular.extend({}, weiboApiParams.trialByPropagandaDepartmentParams, {
                    ObjectIds: item.METADATAID,
                    opinion: content,
                });
                $scope.status.isEsSearch = false;
                $scope.loadingPromise = weiboApiService.trialByPropagandaDepartment(params).then(
                    function (data) {
                        modalDialog.alertType('宣传部送审成功', '', 'success', false, function () {
                            requestData();
                        });
                    },
                    function (data) {
                        modalDialog.alertType('宣传部送审失败', data.message, 'error', 'confirm');
                    }
                );
            });
        };

        /**
         * [directSign description] 直接签发
         * @param  {[object]} item [description] 直接签发的微博对象
         * @return {[type]}      [description]
         */
        $scope.directSign = function (item) {
            if (item.FLOWSTATUS === '23') {
                modalDialog.alertType('宣传部送审中的稿件不能直接签发', '', 'warning', false);
                return;
            }
            if (hasIllegalDoc([item])) {
                modalDialog.alertType('', '长文本微博不能附带图片直接签发！请重新编辑', 'error', 'confirm');
            } else {
                if (item.VIDEOREL && item.VIDEOREL.length) {
                    editCenUploadVideoForXjService.getVideoMark(item.VIDEOREL[0]).then(function (data) {
                        if (data.status !== 1) {
                            modalDialog.alertType('直接签发失败！', '视频转码未完成，请稍后再试', 'error', 'confirm', function () { });
                        } else {
                            directSign(item);
                        }
                    });
                } else {
                    directSign(item);
                }
            }
        };

        /**
         * [directSign description] 直接签发
         * @param   {[type]}  item  [item description]
         * @return  {[type]}        [return description]
         */
        function directSign(item) {
            $scope.loadingPromise = noticeWindowService.getAccountValidityInfo($scope.status.mediaType).then(
                function () {
                    editingCenterWeiBoService.isLock(item.METADATAID).then(function (lockSituation) {
                        if (lockSituation.ISLOCK === 'false') {
                            $scope.status.isEsSearch = false;
                            editingCenterWeiBoService.directSignWeibo([item], false, '20', function (result) {
                                modalDialog.alertType('直接签发成功', '', 'success', false);
                                requestData();
                            }, function(){
                                requestData();
                                modalDialog.alertType('直接签发失败', '', 'error', false);
                            });
                        } else {
                            modalDialog.alertType(
                                lockSituation.LOCKUSERDEPT ? '当前微博已被【' + lockSituation.LOCKUSERDEPT + '-' + lockSituation.LOCKUSER + '】锁定，您此时不能直接签发' : '当前微博已被【' + lockSituation.LOCKUSER + '】锁定，您此时不能直接签发',
                                '',
                                'warning',
                                'confirm',
                                function () { }
                            );
                        }
                    });
                }
            );
        }

        /**
        * [timeSign description] 定时签发触发
        * @param   {[type]}  item  [item description]
        * @return  {[type]}        [return description]
        */
        $scope.timeSign = function (item) {
            if (angular.isDefined(item.FGDERROR) && item.FGDERROR === 1) {
                modalDialog.alertType('稿件不完整，请先完善稿件信息', '', 'error', 'confirm', function () { });
            } else if (hasIllegalDoc([item])) {
                modalDialog.alertType('', '长文本微博不能附带图片定时签发！请重新编辑', 'error', 'confirm');
            } else {
                if (item.VIDEOREL && item.VIDEOREL.length) {
                    editCenUploadVideoForXjService.getVideoMark(item.VIDEOREL[0]).then(function (data) {
                        if (data.status !== 1) {
                            modalDialog.alertType('定时签发失败！', '视频转码未完成，请稍后再试', 'error', 'confirm');
                        } else {
                            timeSign(item);
                        }
                    });
                } else {
                    timeSign(item);
                }
            }
        };

        /**
        * [timeSign description]定时签发
        * @param   {[type]}  item  [item description]
        * @return  {[type]}        [return description]
        */
        function timeSign(item) {
            $scope.loadingPromise = noticeWindowService.getAccountValidityInfo($scope.status.mediaType).then(function () {
                editingCenterWeiBoService.isLock(item.METADATAID).then(function (lockSituation) {
                    if (lockSituation.ISLOCK === 'false') {
                        $scope.status.isEsSearch = false;
                        editingCenterWeiBoService.timeSignWeibo([item], false, '20', function (result) {
                            modalDialog.alertType('定时签发设置成功', '', 'success', false);
                            requestData();
                        }, function() {
                            modalDialog.alertType('定时签发设置失败', '', 'error', true);
                        });
                    } else {
                        modalDialog.alertType(
                            lockSituation.LOCKUSERDEPT ? '当前微博已被【' + lockSituation.LOCKUSERDEPT + '-' + lockSituation.LOCKUSER + '】锁定，您此时不能定时签发' : '当前微博已被【' + lockSituation.LOCKUSER + '】锁定，您此时不能定时签发',
                            '',
                            'warning',
                            'confirm',
                            function () { }
                        );
                    }
                });
            });
        }

        /**
         * [showVersionTime description] 流程版本时间与操作日志
         * @param   {[object]}  item  [item description] 稿件对象
         * @return  {[type]}          [return description]
         */
        $scope.showVersionTime = function (item) {
            editingCenterService.getVersionTime(item, false);
        };

        /**
         * [weiboPreview description] 微博预览
         * @param  {[type]} item [description]
         * @return {[type]}      [description]
         */
        $scope.weiboPreview = function (item) {
            storageListenerService.previewPageTurningStorage($scope.data.items, 'METADATAID,PUBLISHACCOUNTIDS', 'wbPreview');
        };

        /**
         * [revise description]修订
         * @param   {[obj]}  item  [item description]要修订的微博
         * @return  {[null]}       [return description]
         */
        $scope.revise = function (item) {
            var params = {
                serviceid: 'mlf_modifydoc',
                methodname: 'appointDocToUserOfNewMedia',
                SiteId: $state.params.wbchannelid,
                DocIds: item.METADATAID,
                UserId: '',
                MediaType: '5',
            };
            $scope.status.isEsSearch = false;
            editingCenterService.channelsRevise(
                params,
                function (data) {
                    requestData();
                },
                function () {}
            );
        };

        $scope.isPass = function(item, flag) {
            $scope.loadingPromise = newMediaService.isPass([item], flag).then(function(data) {
                requestData();
            });
        };
    },
]);
